import { H5, LI } from "../../../../AbstractElements";
import FeatherIconCom from "../../../../CommonElements/FeatherIcon";

const UserMinus = () => {
  return (
    <LI className="border-0">
      <div className="user-icon success">
        <div className="user-box">
          <FeatherIconCom iconName="UserMinus" className="font-success" />
        </div>
      </div>
      <div>
        <H5 className="mb-1">178,098</H5>
        <span className="font-danger d-flex align-items-center">
          <i className="icon-arrow-down icon-rotate me-1" />
          <span className="f-w-500">-08.89</span>
        </span>
      </div>
    </LI>
  );
};

export default UserMinus;
